import { TYPE_OF_FIELDS_TO_BE_MAPPED } from '../../../features/payment/payment-form/config/fieldsParams'

export const getVisibleTspFields = <T extends { name: string; hidden: boolean }>(payee: { params?: T[] }) =>
  payee.params?.filter((param) => TYPE_OF_FIELDS_TO_BE_MAPPED.includes(param.name) && !param.hidden) || []
